// 自定义的表单组件建议放在该目录下。
// 该目录导出的组件会自动注册到Vue中，并且可以被代码生成的模块扫描到

export default {
  
}